import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, mq } = theme.custom;
    return {
        kpis: { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 16, marginBottom: 20, [mq.sm]: { gridTemplateColumns: '1fr' } },
        kpiLabel: { fontSize: 12, fontWeight: 600, letterSpacing: '0.05em', textTransform: 'uppercase', color: color.text.secondary, marginBottom: 6 },
        kpiValue: { fontSize: 32, fontWeight: 700, lineHeight: 1.1, fontVariantNumeric: 'tabular-nums', display: 'flex', alignItems: 'baseline', gap: 8 },
        kpiHint: { fontSize: 13, color: color.text.secondary, fontWeight: 400 },
        standard: { color: color.primary.main },
        expedited: { color: color.tone.danger.main },
        chart: { height: 240 },
        stack: { display: 'flex', flexDirection: 'column', gap: 20 },
    };
});
